/**
 * API client для админского OKDoc tracking списка и timeline.
 * Дата: 16.03.2026
 */
import { apiClient } from './client';
import type {
  OkdocTrackingDetailsResponse,
  OkdocTrackingFilters,
  OkdocTrackingListResponse,
} from '@/types/okdocTracking';

// 16.03.26: методы чтения OKDoc tracking для админки.
export const okdocTrackingApi = {
  // 16.03.26: получает список ссылок и summary.
  async list(params: OkdocTrackingFilters): Promise<OkdocTrackingListResponse> {
    const { data } = await apiClient.get('/okdoc/links', { params });
    return data;
  },

  // 16.03.26: получает одну ссылку и её timeline.
  async getById(id: string, tenantId?: string): Promise<OkdocTrackingDetailsResponse> {
    const { data } = await apiClient.get(`/okdoc/links/${id}`, {
      params: tenantId ? { tenant_id: tenantId } : undefined,
    });
    return data;
  },
};
